import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { FacebookApiService } from 'src/@order/services/FacebookApi.service';
import { ApiEndPointUrl } from 'src/app/utils/systemEnums';

@Component({
  selector: 'app-after-order-inter-regional',
  templateUrl: './after-order-inter-regional.component.html',
  styleUrls: ['./after-order-inter-regional.component.scss']
})
export class AfterOrderInterRegionalComponent implements OnInit {

  paymentState = {
    status: 0, // 0 === pending || 1 === success || 2 === failed
  }
  orderSuccessData: any;
  orderDetails;
  isPaymentConfirm: boolean = false;
  redirectByWA: boolean = false;
  api_version: string;

  getInterOrderDetailRoute(): string {
    const country = localStorage.getItem('country');
    return country === 'Ghana' ? '/orders/inter-regional-detail/' : '/orders/inter-state-detail/';
  }

  _configuration = {
    API_ENDPOINT: ApiEndPointUrl,
  };

  constructor(
    private _activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private _auth: AuthServiceLocal,
    private _router: Router
  ) { }

  ngOnInit(): void {
    // this.addGoogleTags();

    this._activatedRoute.queryParams.pipe(take(1)).subscribe((res: any) => {
      console.log("res", res);
      this.orderDetails = res;

      this.handlePaymentRedirect(res);
    })
  }

  private handlePaymentRedirect(paymentData: any): void {
    console.log("paymentData", paymentData);

    const orderData = JSON.parse(localStorage.getItem('PENDINGINTERREGIONALORDERDATA') || '{}');
    console.log("orderData", orderData.orderData.orderDetail);

    if (orderData.orderData) {
      this.orderSuccessData = { ...orderData.orderData.orderDetail, finalizeOrder: 1, token: paymentData.token }



      this._auth.updateInterRegionalOrderStatus(this.orderSuccessData).subscribe((res: any) => {
        console.log("res", res);
        this.orderSuccessData.order_id = res.data.id;
        if (res.status == 1) {
          this.paymentState.status = 1;
          // localStorage.removeItem('PENDINGINTERREGIONALORDERDATA');
        } else {
          this.paymentState.status = 2;
        }
      })
    }


  }

  downloadWaybill(): void {
    console.log('Downloading waybill for order:', this.orderSuccessData.order_id);

    const data = {
      interRegionalOrderId: this.orderSuccessData.order_id
    }

    this._auth.downloadWaybill(data).subscribe((res: any) => {
      console.log('Waybill downloaded successfully:', res);
      window.open(res.data, '_blank');
    });
  }

  viewOrderDetail(): void {
    this._router.navigate([this.getInterOrderDetailRoute() + this.orderSuccessData.order_id]);
  }
}